export function addCurrent(permission) {
    return {
        type: 'ADD_CURRENT',
        permission,
    }
}
